import ReactDOM from "react-dom";
import withCSR from "@/components/HOC/withCSR";

export interface PortalProps {
  children?: React.ReactNode;
  root?: HTMLElement | string;
}

export const Portal = withCSR(({ children, root }: PortalProps) => {
  let rootDOM: HTMLElement | null = null;
  if (root) {
    if (typeof root === "string") {
      rootDOM = document.getElementById(root);
    } else if (root instanceof HTMLElement) {
      rootDOM = root;
    }
  }
  if (!rootDOM) {
    rootDOM = document.body;
  }

  return ReactDOM.createPortal(children, rootDOM);
});
